"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var React = __importStar(require("react"));
var style = renderer_1.StyleSheet.create({
    chipContainer: {
        borderRadius: 50,
        paddingVertical: 1,
        height: 17,
        width: 75,
        alignItems: "center",
    },
    text: {
        color: "white",
        fontFamily: "Quicksand",
        fontWeight: 700,
        fontSize: 12,
    },
});
var PassFailChip = function (_a) {
    var result = _a.result;
    return (React.createElement(renderer_1.View, { style: [
            style.chipContainer,
            { backgroundColor: result === "PASS" ? "#9aca7c" : "red" },
        ] },
        React.createElement(renderer_1.Text, { style: style.text }, result)));
};
exports.default = PassFailChip;
//# sourceMappingURL=index.js.map